import enMessages from '../locales/en_US';
import FeaturesLocals from 'features/configs/l10n';

const EnLang = {
  messages: {
    ...enMessages,
    ...FeaturesLocals.en
  },
  locale: 'en-US',
};
export default EnLang;
